import { render, staticRenderFns } from "./supplier_report_statuses.vue?vue&type=template&id=0d2ebd1c&scoped=true&"
import script from "./supplier_report_statuses.vue?vue&type=script&lang=js&"
export * from "./supplier_report_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ebd1c",
  null
  
)

export default component.exports